module.exports = __webpack_public_path__ + "img/car-14.54a3ec5f.jpg";